import React from 'react';

interface VehicleHistorySidebarProps {
  open: boolean;
  onClose: () => void;
  data: any[];
  avg?: number | null;
  mode?: number | null;
  min?: number | null;
  max?: number | null;
  count?: number | null;
  lastUsed?: string | null;
  onLoadMore: () => void;
  loading: boolean;
  vehicleNumber: string;
  hasMore?: boolean;
}

const formatNumber = (val: any) => {
  if (val === undefined || val === null || val === '') return '';
  const num = Number(String(val).replace(/[^0-9.-]/g, ''));
  if (isNaN(num)) return val;
  return num.toLocaleString('ko-KR');
};

const VehicleHistorySidebar: React.FC<VehicleHistorySidebarProps> = ({ 
  open, 
  onClose, 
  data, 
  avg, 
  mode, 
  min, 
  max, 
  count, 
  lastUsed, 
  onLoadMore, 
  loading, 
  vehicleNumber,
  hasMore = true
}) => {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: 420, height: 'calc(100vh - 100px)', maxHeight: 'calc(100vh - 100px)', background: '#fff',
      boxShadow: '2px 0 12px rgba(0,0,0,0.08)', zIndex: 200, padding: 24, display: 'flex', flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <div style={{ flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <b style={{ fontSize: 20, color: '#1976d2' }}>{vehicleNumber} 단가 이력 ( 지불운송비 ) </b>
        <button onClick={onClose} style={{ fontSize: 18, background: 'none', border: 'none', cursor: 'pointer' }}>✕</button>
      </div>
      <div style={{ flexShrink: 0, marginBottom: 16, background: '#f5f7fa', borderRadius: 8, padding: 12, fontSize: 15, color: '#333' }}>
        {avg !== undefined && avg !== null && <div>평균 운임: <b>{formatNumber(avg)}</b>원</div>}
        {mode !== undefined && mode !== null && <div>최빈 운임: <b>{formatNumber(mode)}</b>원</div>}
        {min !== undefined && min !== null && <div>최소 운임: <b>{formatNumber(min)}</b>원</div>}
        {max !== undefined && max !== null && <div>최대 운임: <b>{formatNumber(max)}</b>원</div>}
        {count !== undefined && count !== null && <div>1년치 운행 건수: <b>{count}</b></div>}
        {lastUsed && <div>마지막 운행일: <b>{lastUsed}</b></div>}
      </div>
      <div style={{ flex: '1 1 0', minHeight: 0, height: 0, overflowY: 'auto', overflowX: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15 }}>
          <thead>
            <tr style={{ background: '#f5f7fa' }}>
              <th style={{ padding: 6, borderBottom: '1px solid #ddd' }}>운송구간</th>
              <th style={{ padding: 6, borderBottom: '1px solid #ddd' }}>차종</th>
              <th style={{ padding: 6, borderBottom: '1px solid #ddd' }}>지불운송비</th>
              <th style={{ padding: 6, borderBottom: '1px solid #ddd' }}>날짜</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', color: '#888', padding: 24 }}>이력이 없습니다.</td>
              </tr>
            )}
            {data.map((row, i) => (
              <tr key={i}>
                <td style={{ padding: 6, borderBottom: '1px solid #eee' }}>{row.route}</td>
                <td style={{ padding: 6, borderBottom: '1px solid #eee' }}>{row.cargo}</td>
                <td style={{ padding: 6, borderBottom: '1px solid #eee', textAlign: 'right' }}>{formatNumber(row.paymentAmount)}</td>
                <td style={{ padding: 6, borderBottom: '1px solid #eee' }}>{row.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{
        textAlign: 'center',
        paddingTop: 12,
        flexShrink: 0
      }}>
        {hasMore ? (
          <button onClick={onLoadMore} disabled={loading} style={{
            padding: '8px 24px', borderRadius: 5, border: 'none', background: '#1976d2', color: '#fff',
            fontWeight: 600, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1
          }}>
            {loading ? '로딩 중...' : '더보기'}
          </button>
        ) : (
          <span style={{ fontSize: 15, color: '#666' }}>마지막 데이터 입니다</span>
        )}
      </div>
    </div>
  );
};

export default VehicleHistorySidebar; 